import Model, { attr } from '@ember-data/model';

export default class TrackingConsentPreferenceModel extends Model {
  @attr('boolean') advertising;
  @attr('boolean') analytics;
  @attr('boolean') functional;
}
